import * as moment from 'moment';
import React, {
    PureComponent
} from 'react';
import ReactExport from "react-export-excel";
import Loader from 'react-loader-spinner';
import { withRouter } from 'react-router-dom';
import { Button, Col, Panel, PanelGroup, Row, Table, Timeline } from 'rsuite';
import EditItemDrawer from './EditItemDrawer';
import { formatBitToTrueFalse, formatNumberForAPI, formatStringForAPI, formatTrueFalseToBit, replaceNullWithEmpty } from '../../../../resources/logic/functions';


const mountRef = React.createRef();

class ItemDetail extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

            sortTableColumn: '',
            sortTableType: null,

            // Table Check Box
            checkedKeys: [],


            //Add New Item
            showEditItemDrawer: false,

            editCustomerID: null,
            editWarehouseID: null,
            editSkuID: null,
            editSku: '',
            editProjectID: null,
            editProject: null,
            editCustomerRefID: null,
            editCustomerRef: null,
            editNotes: '',
            editProductName: '',
            editProductDetails: '',
            editProductURL: '',
            editProductCountryofOrigin: '',
            editHTSCode: '',
            editPGAFlag: false,
            editTransactionID: null,

            editUPC: '',
            editPrimUomID: null,
            editPackUnitID: null,
            editPackingUomQty: null,
            editLength: null,
            editWidth: null,
            editHeight: null,
            editUomID: 1,
            editWeight: null,
            editUowID: 1,



        };

        this.onChangeState = this.onChangeState.bind(this);


        //Edit
        this.onClickEditSku = this.onClickEditSku.bind(this);
        this.onClickConfirmEditItem = this.onClickConfirmEditItem.bind(this);
        this.closeEditItemDrawer = this.closeEditItemDrawer.bind(this);
        this.resetEditState = this.resetEditState.bind(this);



    }




    componentDidMount() {
        this.loadSortFromStorage()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.warehouseSelection !== this.props.warehouseSelection) {
            this.setState({
                checkedKeys: []
            });
        }
        if (prevProps.customerSelection !== this.props.customerSelection) {
            this.setState({
                checkedKeys: []
            });
        }
        if (prevProps.InventoryLotSkuRefPostSuccessful !== this.props.InventoryLotSkuRefPostSuccessful && this.props.InventoryLotSkuRefPostSuccessful) {
            this.closeEditItemDrawer()
        }

    }


    // Table Sort
    saveSortTosessionStorage(sortColumn, sortType) {
        try {
            sessionStorage.setItem('sortcolumn', sortColumn)
        }
        catch (e) { }
        try {
            sessionStorage.setItem('sortType', sortType)
        }
        catch (e) { }
        try {
            sessionStorage.setItem('sortURLPathname', this.props.location.pathname)
        }
        catch (e) { }
    }
    loadSortFromStorage() {
        var sortColumn = null
        var sortType = null
        var pathName = null
        try {
            sortColumn = sessionStorage.getItem('sortcolumn')
        }
        catch (e) { }
        try {
            sortType = sessionStorage.getItem('sortType')
        }
        catch (e) { }
        try {
            pathName = sessionStorage.getItem('sortURLPathname')
        }
        catch (e) { }
        if (pathName === this.props.location.pathname) {

            this.handleSortColumn(sortColumn, sortType)
        }
    }
    handleSortColumn(sortColumn, sortType) {
        this.setState({
            loading: true
        });
        this.saveSortTosessionStorage(sortColumn, sortType)
        setTimeout(() => {
            this.setState({
                sortColumn,
                sortType,
                loading: false
            });
        }, 100);
    }


    //Change State
    onChangeState(e, statename) {
        this.setState({
            [statename]: e
        });

        if (statename === 'editLength' || statename === 'editWidth' || statename === 'editHeight') {
            if (e !== '' && e !== null && this.state.editUomID === null) {
                this.setState({
                    editUomID: 1
                });
            }
        }

        if (statename === 'editWeight' ) {
            if (e !== '' && e !== null && this.state.editUowID === null) {
                this.setState({
                    editUowID: 1
                });
            }
        }

    }







    //Add New
    onClickEditSku(e) {

        this.resetEditState()


        try {


            var CustomerID = this.props.InventorySkuRefData[0].CustomerID
            var WarehouseID = this.props.InventorySkuRefData[0].WarehouseID

            var SkuID = this.props.InventorySkuRefData[0].SkuID
            var SKU = this.props.InventorySkuRefData[0].SKU
            var Project = this.props.InventorySkuRefData[0].ProjectID
            var CustomerRef = this.props.InventorySkuRefData[0].CustomerRefID
            var Notes = this.props.InventorySkuRefData[0].Notes
            var ProductName = this.props.InventorySkuRefData[0].ProductName
            var ProductDetails = this.props.InventorySkuRefData[0].ProductDetails
            var ProductURL = this.props.InventorySkuRefData[0].ProductURL
            var ProductCountryofOrigin = this.props.InventorySkuRefData[0].ProductCountryofOrigin
            var HTSCode = this.props.InventorySkuRefData[0].HTSCode
            var PGAFlag = this.props.InventorySkuRefData[0].PGAFlag
            var TransactionID = this.props.InventorySkuRefData[0].TransactionID

            var uPC = this.props.InventorySkuRefData[0].uPC
            var PrimUomID = this.props.InventorySkuRefData[0].PrimUomID
            var PackUnitID = this.props.InventorySkuRefData[0].PackUnitID
            var PackingUomQty = this.props.InventorySkuRefData[0].PackingUomQty
            var Length = this.props.InventorySkuRefData[0].Length
            var Width = this.props.InventorySkuRefData[0].Width
            var Height = this.props.InventorySkuRefData[0].Height
            var UomID = this.props.InventorySkuRefData[0].UomID
            var Weight = this.props.InventorySkuRefData[0].Weight
            var UowID = this.props.InventorySkuRefData[0].UowID

            this.setState({
                editCustomerID: CustomerID,
                editWarehouseID: WarehouseID,
                editSkuID: SkuID,
                editSku: SKU,
                editProjectID: null,
                editProject: Project,
                editCustomerRefID: null,
                editCustomerRef: CustomerRef,
                editNotes: Notes,
                editProductName: ProductName,
                editProductDetails: ProductDetails,
                editProductURL: ProductURL,
                editProductCountryofOrigin: ProductCountryofOrigin,
                editHTSCode: HTSCode,
                editPGAFlag: PGAFlag,
                editTransactionID: TransactionID,

                editUPC: uPC,
                editPrimUomID: PrimUomID,
                editPackUnitID: PackUnitID,
                editPackingUomQty: PackingUomQty,
                editLength: Length,
                editWidth: Width,
                editHeight: Height,
                editUomID: UomID,
                editWeight: Weight,
                editUowID: UowID,

            });

        } catch (e) {

        }


        this.forceUpdate()




        this.setState({
            showEditItemDrawer: true
        });

    }

    resetEditState() {

        this.setState({
            editCustomerID: null,
            editWarehouseID: null,
            editSku: '',
            editProjectID: null,
            editProject: null,
            editCustomerRefID: null,
            editCustomerRef: null,
            editNotes: '',
            editProductName: '',
            editProductDetails: '',
            editProductURL: '',
            editProductCountryofOrigin: '',
            editHTSCode: '',
            editPGAFlag: false,
            editTransactionID: null,

            editUPC: '',
            editPrimUomID: null,
            editPackUnitID: null,
            editPackingUomQty: null,
            editLength: null,
            editWidth: null,
            editHeight: null,
            editUomID: 1,
            editWeight: null,
            editUowID: 1,

        });

    }


    onClickConfirmEditItem() {
        var newUomID = null
        var newUowID = null

        if (this.state.editLength || this.state.editWidth || this.state.editHeight) {
            // At least one of them has a value that is not '' or null
            newUomID = this.state.editUomID
        } else {
            // All of them are either '' or null
            newUomID = null
        }

        if (this.state.editWeight) {
            // At least one of them has a value that is not '' or null
            newUowID = this.state.editUowID
        } else {
            // All of them are either '' or null
            newUowID = null
        }

        this.props.inventoryLotSkuRefPost(
            this.props.currentUserEmail,
            this.props.userSignInData.AuthToken,
            this.state.editWarehouseID,
            this.state.editCustomerID,
            formatNumberForAPI(this.state.editSkuID),
            null,
            null,
            null,
            formatStringForAPI(this.state.editProject),
            null,
            formatStringForAPI(this.state.editCustomerRef),
            formatStringForAPI(this.state.editNotes),
            formatStringForAPI(this.state.editProductName),
            formatStringForAPI(this.state.editProductDetails),
            formatStringForAPI(this.state.editProductURL),
            formatStringForAPI(this.state.editProductCountryofOrigin),
            formatStringForAPI(this.state.editHTSCode),
            formatTrueFalseToBit(this.state.editPGAFlag),
            formatNumberForAPI(this.state.editTransactionID),

            formatStringForAPI(this.state.editUPC),
            formatStringForAPI(this.state.editPrimUomID),
            formatStringForAPI(this.state.editPackUnitID),
            formatStringForAPI(this.state.editPackingUomQty),
            formatStringForAPI(this.state.editLength),
            formatStringForAPI(this.state.editWidth),
            formatStringForAPI(this.state.editHeight),
            formatStringForAPI(newUomID),
            formatStringForAPI(this.state.editWeight),
            formatStringForAPI(newUowID)

        )
        //     }
        // }
        // else { window.alert('Please select one Warehouse and one Customer to save data.') }

    }


    closeEditItemDrawer(e) {

        this.setState({
            showEditItemDrawer: false
        });

        this.resetEditState()
    }



    render() {

        if (this.props.isInventoryLotSkuRefLoading) {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                    <Loader
                        type="TailSpin"
                        color="#3396E5"
                        height="50"
                        width="50"
                    />
                    <p style={{ marginTop: '20px', fontSize: '20px', color: '#3396E5' }}>Please wait...</p>
                </div>
            );
        }




        let skuRefDetailsDiv;
        let pageHeader;
        if (this.props.isInventorySkuRefLoading) {
            pageHeader = <div>Inventory Management - Item Details</div>

            skuRefDetailsDiv = <div align="center">
                <section className="panel">
                </section>
                <Loader
                    type="TailSpin"
                    color="#3396E5"
                    height="50"
                    width="50"
                />
            </div>

        }
        else if (typeof (this.props.InventorySkuRefData[0]) !== 'undefined' && this.props.InventorySkuRefData != null) {
            try {
                var skuName = this.props.InventorySkuRefData[0].SKU.toString()
                pageHeader = <div style={{ marginBottom: '15px' }}>  {'Inventory Management - Item: ' + skuName} </div>
            }
            catch (e) {
                pageHeader = <div>Inventory Management - Item Details</div>
            }

            skuRefDetailsDiv =
                <div>
                    <Row >
                        <Col md={12} sm={24}>
                            <Panel bordered style={{ marginBottom: 10 }} header={
                                <div style={{ float: 'right' }}>

                                </div>
                            }>
                                SKU: <strong>{this.props.InventorySkuRefData[0].SKU}</strong>
                                <br />
                                Product Name: <strong>{this.props.InventorySkuRefData[0].ProductName}</strong>
                                <br />
                                Product Details: <strong>{this.props.InventorySkuRefData[0].ProductDetails}</strong>
                                <br />
                                Product URL: <strong>
                                    <a
                                        href={this.props.InventorySkuRefData[0].ProductURL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: 'blue', textDecoration: 'underline' }}
                                    >
                                        {this.props.InventorySkuRefData[0].ProductURL}
                                    </a>
                                </strong>
                                <br />
                                Product Country of Origin: <strong>{this.props.InventorySkuRefData[0].ProductCountryofOrigin}</strong>
                                <br />
                                HTS Code: <strong>{this.props.InventorySkuRefData[0].HTSCode}</strong>
                                <br />

                            </Panel>

                        </Col>
                        <Col md={12} sm={24}>
                            <Panel bordered style={{ marginBottom: 10 }} header={
                                <div style={{ float: 'right' }}>
                                    <Button style={{ float: 'right' }} onClick={(e) => { this.onClickEditSku(e) }} >Edit</Button>
                                </div>
                            }>
                                Warehouse: <strong>{this.props.InventorySkuRefData[0].WarehouseName}</strong>
                                <br />
                                Customer: <strong>{this.props.InventorySkuRefData[0].CustomerName}</strong>
                                <br />
                                Customer Ref: <strong>{this.props.InventorySkuRefData[0].CustomerRef}</strong>
                                <br />
                                Project: <strong>{this.props.InventorySkuRefData[0].Project}</strong>
                                <br />
                                PGA Flag: <strong>{formatBitToTrueFalse(this.props.InventorySkuRefData[0].PGAFlag)}</strong>
                                <br />
                                Notes: <strong>{this.props.InventorySkuRefData[0].Notes}</strong>
                                <br />
                            </Panel>

                        </Col>
                    </Row>



                    <Row >
                        <Col md={24} sm={24}>
                            <Panel bordered style={{ marginBottom: 10 }} >
                                UPC: <strong>{this.props.InventorySkuRefData[0].UPC}</strong>
                                <br />
                                Primary UOM: <strong>{this.props.InventorySkuRefData[0].PrimUOM}</strong>
                                <br />
                                Packaging Unit: <strong>{this.props.InventorySkuRefData[0].PackagingUnit}</strong>
                                <br />
                                Packing UOM Qty: <strong>{this.props.InventorySkuRefData[0].PackingUomQty}</strong>
                                <br />
                                Dimensions: <strong>
                                    {replaceNullWithEmpty(this.props.InventorySkuRefData[0]['Length'])}
                                    {this.props.InventorySkuRefData[0]['Width'] ? ' x ' + replaceNullWithEmpty(this.props.InventorySkuRefData[0]['Width']) : ''}
                                    {this.props.InventorySkuRefData[0]['Height'] ? ' x ' + replaceNullWithEmpty(this.props.InventorySkuRefData[0]['Height']) : ''}
                                    {this.props.InventorySkuRefData[0]['UOM'] ? ' ' + replaceNullWithEmpty(this.props.InventorySkuRefData[0]['UOM']) : ''}
                                </strong>

                                <br />
                                Weight: <strong>{replaceNullWithEmpty(this.props.InventorySkuRefData[0].Weight) + ' ' + replaceNullWithEmpty(this.props.InventorySkuRefData[0].UOW)}</strong>
                                <br />

                            </Panel>

                        </Col>

                    </Row>




                </div>


        }
        else {
            pageHeader = <div>Inventory Management - SKU</div>
            skuRefDetailsDiv = <div></div>
        }












        let itemHistoryTimeline;
        if (this.props.isInventoryLotSkuRefHistoryGetLoading) {
            itemHistoryTimeline =
                <div align="center">
                    <section className="panel">
                    </section>
                    <Loader
                        type="TailSpin"
                        color="#3396E5"
                        height="50"
                        width="50"
                    />
                </div>
        }
        else if (typeof (this.props.InventoryLotSkuRefHistoryData[0]) !== 'undefined' && this.props.InventoryLotSkuRefHistoryData != null) {
            itemHistoryTimeline =
                <div>
                    <Row >
                        <Col md={24} sm={24}>
                            <Panel bordered header="Item History" style={{ marginBottom: 10 }}>
                                <Timeline>
                                    {this.props.InventoryLotSkuRefHistoryData.map(item => (
                                        <Timeline.Item>
                                            {item.DT}  &nbsp;
                                            {item.EmailAddr}
                                            <l><br />{item.HistoryType} &nbsp;
                                            </l>
                                            {item.Project != null ? <l><br /> Project:  {item.Project} </l> : ' '}
                                            {item.CustomerRef != null ? <l><br /> Customer Ref:  {item.CustomerRef} </l> : ' '}
                                            {item.ProductName != null ? <l><br /> Product Name:  {item.ProductName} </l> : ' '}
                                            {item.ProductDetails != null ? <l><br /> Product Details:  {item.ProductDetails} </l> : ' '}
                                            {item.ProductURL != null ? <l><br /> Product URL:  {item.ProductURL} </l> : ' '}

                                            {item.ProductCountryofOrigin != null ? <l><br /> Product Country of Origin:  {item.ProductCountryofOrigin} </l> : ' '}
                                            {item.HTSCode != null ? <l><br /> HTS Code:  {item.HTSCode} </l> : ' '}
                                            {item.PGAFlag != null ? <l><br /> PGA Flag:  {item.PGAFlag === true ? "True" : "False"} </l> : ' '}




                                            {item.UPC != null ? <l><br /> UPC:  {item.UPC} </l> : ' '}
                                            {item.PrimUOM != null ? <l><br /> Primary UOM:  {item.PrimUOM} </l> : ' '}
                                            {item.PackagingUnit != null ? <l><br /> Packaging Unit:  {item.PackagingUnit} </l> : ' '}
                                            {item.PackingUomQty != null ? <l><br /> Packing UOM Qty:  {item.PackingUomQty} </l> : ' '}
                                            {item.Length != null ? <l><br /> Length:  {item.Length} </l> : ' '}
                                            {item.Width != null ? <l><br /> Width:  {item.Width} </l> : ' '}
                                            {item.Height != null ? <l><br /> Height:  {item.Height} </l> : ' '}
                                            {item.UOM != null ? <l><br /> UOM:  {item.UOM} </l> : ' '}
                                            {item.Weight != null ? <l><br /> Weight:  {item.Weight} </l> : ' '}
                                            {item.UOW != null ? <l><br /> Unit of Weight:  {item.UOW} </l> : ' '}




                                            {item.Notes != null ? <l><br /> Notes:  {item.Notes} </l> : ' '}


                                        </Timeline.Item>
                                    ))}
                                </Timeline>

                            </Panel>
                        </Col>
                    </Row>

                </div>
        }
        else {
            itemHistoryTimeline = <div></div>
        }





        return (
            <div>
                <h3>
                    {pageHeader}
                </h3>



                <PanelGroup>
                    {skuRefDetailsDiv}
                </PanelGroup>

                {itemHistoryTimeline}


                <EditItemDrawer {...this.props} state={this.state} onChangeState={this.onChangeState} confirm={this.onClickConfirmEditItem} close={this.closeEditItemDrawer} />

            </div>
        );

    }
}

export default withRouter(ItemDetail);
